import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import MaterialTable from '@material-table/core';
import flowRight from 'lodash.flowright';

import { mapTableOptions } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import { actions as reduxActions } from '../reducers';
import FilterButton from '../../../partials/tableCustomButtons/FilterButton';
import tableColumns from './tableColumns';
import useLocalTableStore from '../../../utils/useLocalTableStore';
import getVacations from '../actions/getVacations';
import CustomTableTitle from '../../../partials/CustomTableTitle';
import { translate } from '../../../i18n/I18nProvider';
import customTableIcons from '../../../partials/tableIcons/customTableIcons';
import { actions as editVacationReduxActions } from '../../../modals/editVacation/reducers';
import AddButton from '../../../partials/tableCustomButtons/AddButton';
import RefreshButton from '../../../partials/tableCustomButtons/RefreshButton';

const VacationsTable = ({
  vacations,
  columns,
  setColumns,
  getVacations,
  isLoading,
  openEditVacation,
  tagsOptions
}) => {
  const [filtering, setFiltering] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { localization, language } = useTableLocalization();

  useEffect(() => {
    getVacations();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (refresh) {
      getVacations();
      setRefresh(false);
    }
    // eslint-disable-next-line
  }, [refresh]);

  const tableDefaultColumns = useMemo(() => {
    return tableColumns();
  }, []);

  const {
    pageSize,
    onChangeRowsPerPage,
    onChangeColumnHidden
  } = useLocalTableStore({
    tableName: 'Vacations-2.2',
    setColumns,
    tableDefaultColumns,
    language
  });

  const actions = useMemo(
    () => [
      {
        icon: () => <FilterButton />,
        onClick: () => {
          setFiltering(!filtering);
        },
        isFreeAction: true,
        tooltip: translate('BUTTON.FILTER')
      },
      {
        icon: () => <AddButton buttonText="BUTTON.ADD" />,
        onClick: () => openEditVacation({ tagsOptions }),
        isFreeAction: true,
        tooltip: translate('VACATIONS.ADD_VACATION')
      },
      {
        icon: () => <RefreshButton tableHeader={true} />,
        onClick: () => setRefresh(true),
        isFreeAction: true
      }
    ],
    // eslint-disable-next-line
    [filtering, tagsOptions]
  );

  const options = useMemo(() => {
    return {
      ...mapTableOptions({ exportData: false }),
      selection: false,
      filtering,
      pageSize
    };
  }, [filtering, pageSize]);

  return (
    <>
      <MaterialTable
        title={<CustomTableTitle text="MENU.VACATIONS" isLoading={isLoading} />}
        icons={customTableIcons}
        actions={actions}
        columns={columns}
        data={vacations}
        options={options}
        localization={localization}
        onChangeColumnHidden={onChangeColumnHidden}
        onRowsPerPageChange={onChangeRowsPerPage}
      />
    </>
  );
};

const mapStatesToProps = ({ vacations, loader }) => {
  return {
    ...vacations,
    isLoading: loader.isSpinVisible
  };
};

const mapDispatchToProps = {
  getVacations,
  setColumns: reduxActions.setColumns,
  openEditVacation: editVacationReduxActions.openEditVacation
};

export default flowRight(connect(mapStatesToProps, mapDispatchToProps))(
  VacationsTable
);
